import Vue from 'vue'
import Router from 'vue-router'
// import index from '@/pages/index/index'
const welcome = () =>
    import( /* webpackChunkName: "Order_Report" */ '@/pages/index/welcome')
const index = () =>
    import( /* webpackChunkName: "Order_Report" */ '@/pages/index/index')
// import home from '@/pages/index/home'
const home = () =>
    import( /* webpackChunkName: "Order_Report" */ '@/pages/index/home')
// import login from '@/pages/index/login'
const login = () =>
    import( /* webpackChunkName: "Order_Report" */ '@/pages/index/login')
// import orderList from '@/pages/member/orderList'
const orderList = () =>
    import( /* webpackChunkName: "Order_Report" */ '@/pages/member/orderList')
const repairList = () =>
    import( /* webpackChunkName: "Order_Report" */ '@/pages/member/repairList')
const repairAdd = () =>
    import( /* webpackChunkName: "Order_Report" */ '@/pages/member/repairAdd')
const returnGoodList = () =>
    import( /* webpackChunkName: "Order_Report" */ '@/pages/member/returnGoodList')
const returnGoodDetail = () =>
    import( /* webpackChunkName: "Order_Report" */ '@/pages/member/returnGoodDetail')
const returnDetails = () =>
    import( /* webpackChunkName: "Order_Report" */ '@/pages/member/returnDetails')
// import orderDetail from '@/pages/member/orderDetail'
const orderDetail = () =>
    import( /* webpackChunkName: "Order_Report" */ '@/pages/member/orderDetail')
// import address from '@/pages/member/address'
const repairDetails = () =>
    import( /* webpackChunkName: "Order_Report" */ '@/pages/member/repairDetails')
const workOrderList = () =>
    import( /* webpackChunkName: "Order_Report" */ '@/pages/member/workOrderList')
const workOrderEdit = () =>
    import( /* webpackChunkName: "Order_Report" */ '@/pages/member/workOrderEdit')
const viewWorkOrder = () =>
    import( /* webpackChunkName: "Order_Report" */ '@/pages/member/viewWorkOrder')
// import address from '@/pages/member/address'
const address = () =>
    import( /* webpackChunkName: "Order_Report" */ '@/pages/member/addressVc')
// import editAddress from '@/pages/member/editAddress'
const editAddress = () =>
    import( /* webpackChunkName: "Order_Report" */ '@/pages/member/editAddress')
// import basicinfo from '@/pages/member/basicinfo'
const basicinfo = () =>
    import( /* webpackChunkName: "Order_Report" */ '@/pages/member/basicinfoVc')
// import myaccount from '@/pages/member/myaccount'
const myaccount = () =>
    import( /* webpackChunkName: "Order_Report" */ '@/pages/member/myaccount')
// import newlyincreased from '@/pages/member/newlyincreased'
const newlyincreased = () =>
    import( /* webpackChunkName: "Order_Report" */ '@/pages/member/newlyincreased')
// import updatepassword from '@/pages/member/updatepassword'
const aftersalesservice = () =>
    import( /* webpackChunkName: "Order_Report" */ '@/pages/member/aftersalesservice')
// import updatepassword from '@/pages/member/updatepassword'
const updatepassword = () =>
    import( /* webpackChunkName: "Order_Report" */ '@/pages/member/updatepassword')
// import myProject from '@/pages/member/myProject'
const myProject = () =>
    import( /* webpackChunkName: "Order_Report" */ '@/pages/member/myProject')
// import registerRetail from '@/pages/index/registerRetail'
const registerRetail = () =>
    import( /* webpackChunkName: "Order_Report" */ '@/pages/index/registerRetail')
// import registerTrade from '@/pages/index/registerTrade'
const registerTrade = () =>
    import( /* webpackChunkName: "Order_Report" */ '@/pages/index/registerTrade')
// import designers from '@/pages/designers/designers'
const designers = () =>
    import( /* webpackChunkName: "Order_Report" */ '@/pages/designers/designers')
// import designerDetail from '@/pages/designers/designerDetail'
const designerDetail = () =>
    import( /* webpackChunkName: "Order_Report" */ '@/pages/designers/designerDetail')
const aftersale = () =>
    import( /* webpackChunkName: "Order_Report" */ '@/pages/member/aftersale')
// import designerDetailInStock from '@/pages/designers/designerDetailInStock'
const designerDetailInStock = () =>
    import( /* webpackChunkName: "Order_Report" */ '@/pages/designers/designerDetailInStock')
// import tips from '@/pages/tips/tips'
const tips = () =>
    import( /* webpackChunkName: "Order_Report" */ '@/pages/tips/tips')
// import tipsDetail from '@/pages/tips/tipsDetail'
const tipsDetail = () =>
    import( /* webpackChunkName: "Order_Report" */ '@/pages/tips/tipsDetail')
// import ourstory from '@/pages/ourcompany/ourstory'
const ourstory = () =>
    import( /* webpackChunkName: "Order_Report" */ '@/pages/ourcompany/ourstory')
// import joinTeam from '@/pages/ourcompany/joinTeam'
const joinTeam = () =>
    import( /* webpackChunkName: "Order_Report" */ '@/pages/ourcompany/joinTeam')
// import showRooms from '@/pages/showrooms/showRooms'
const showRooms = () =>
    import( /* webpackChunkName: "Order_Report" */ '@/pages/showrooms/showRooms')
const showRoomsDetail = () =>
    import( /* webpackChunkName: "Order_Report" */ '@/pages/showrooms/showRoomsDetail')
// import inspirationList from '@/pages/inspiration/inspirationList'
const inspirationList = () =>
    import( /* webpackChunkName: "Order_Report" */ '@/pages/inspiration/inspirationList')
// import inspiration from '@/pages/inspiration/inspiration'
const inspiration = () =>
    import( /* webpackChunkName: "Order_Report" */ '@/pages/inspiration/inspiration')
// import inspirationDetail from '@/pages/inspiration/inspirationDetail'
const inspirationDetail = () =>
    import( /* webpackChunkName: "Order_Report" */ '@/pages/inspiration/inspirationDetail')
// import goodsList from '@/pages/goods/goodsList'
const goodsList = () =>
    import( /* webpackChunkName: "Order_Report" */ '@/pages/goods/goodsList')
// import goodsDetail from '@/pages/goods/goodsDetail'
const goodsDetail = () =>
    import( /* webpackChunkName: "Order_Report" */ '@/pages/goods/goodsDetail')
const specialOfferList = () =>
    import( /* webpackChunkName: "Order_Report" */ '@/pages/goods/specialOfferList')
// import goodsDetail from '@/pages/goods/specialOfferEdit'
const specialOfferEdit = () =>
    import( /* webpackChunkName: "Order_Report" */ '@/pages/goods/specialOfferEdit')
// import picView from '@/pages/goods/picView'
const picView = () =>
    import( /* webpackChunkName: "Order_Report" */ '@/pages/goods/picView')
// import cart from '@/pages/goods/cart'
const cart = () =>
    import( /* webpackChunkName: "Order_Report" */ '@/pages/goods/cart')
// import wishlist from '@/pages/member/wishlist'
const wishlist = () =>
    import( /* webpackChunkName: "Order_Report" */ '@/pages/member/wishList')
// import checkout from '@/pages/goods/checkout'
const checkout = () =>
    import( /* webpackChunkName: "Order_Report" */ '@/pages/goods/checkout')
// import inStock from '@/pages/member/instock'
const inStock = () =>
    import( /* webpackChunkName: "Order_Report" */ '@/pages/member/inStock')
const aftersaleDetails = () =>
    import( /* webpackChunkName: "Order_Report" */ '@/pages/member/aftersaleDetails')
const rointReward = () =>
    import( /* webpackChunkName: "Order_Report" */ '@/pages/goods/rointReward')
const contactUs = () =>
    import( /* webpackChunkName: "Order_Report" */ '@/pages/wy/contactUs')
// import joinOurTeam from '@/pages/wy/joinOurTeam'
const joinOurTeam = () =>
    import( /* webpackChunkName: "Order_Report" */ '@/pages/wy/joinOurTeam')
const offlinePayment = () => import('@/pages/goods/offlinePayment')
const Projectrecord = () => import('@/pages/member/Projectrecord')
const wxPayment = () => import('@/pages/goods/wxPayment')
const myIntegral = () => import('@/pages/member/myIntegral')
const myrecommend = () => import('@/pages/member/myrecommend')
const commission = () => import('@/pages/member/mycommission')
const addToCart = () => import('@/pages/member/addToCart')
const addProject = () => import('@/pages/member/addProject')
const viewProject = () => import('@/pages/member/viewProject')
const yzzInspiration = () => import('@/pages/yzzInspiration/index')
const yzzInspirationDetail = () => import('@/pages/yzzInspiration/detail')

Vue.use(Router)

export default new Router({
    routes: [{
        path: '/',
        redirect: '/index',
        children: []
    }, {
        path: '/welcome',
        name: 'welcome',
        component: welcome
    },
    {
        path: '/picView/:url',
        name: 'picView',
        component: picView
    },
    {
        path: '/index',
        name: 'index',
        component: index,
        children: [{
            path: '/index',
            name: 'home',
            component: home,
            meta: {
                title: localStorage.getItem('aspName')
            }
        },
        {
            path: '/login',
            name: 'login',
            component: login,
            meta: {
                title: localStorage.getItem('aspName')
            }
        },
        {
            path: '/restPassword',
            name: 'restPassword',
            component: () => import("@/pages/index/restPassword")
        },
        {
            path: '/forgotpassword',
            name: 'forgotpassword',
            component: () => import("@/pages/index/forgotpassword")
        },
        {
            path: '/designers',
            name: 'designers',
            component: designers,
            meta: {
                title: localStorage.getItem('aspName')
            }
        },
        {
            path: '/addToCart',
            name: 'addToCart',
            component: addToCart
        },
        // {
        //     path: '/member',
        //     name: 'inStock',
        //     component: inStock,
        //     meta: {
        //         title: 'In Stock'
        //     }
        // },
        {
            path: '/member/:goodsTypeId/:label',
            name: 'inStock',
            component: inStock,
            meta: {
                title: localStorage.getItem('aspName'),
                keepAlive: true
            }
        },
        {
            path: '/designerDetail/:id',
            name: 'designerDetail',
            component: designerDetail
        },
        {
            path: '/designerDetailInStock',
            name: 'designerDetailInStock',
            component: designerDetailInStock
        },
        // {
        //     path: '/designerDetailInStock/:goodsTypeId',
        //     name: 'designerDetailInStock',
        //     component: designerDetailInStock
        // },
        {
            path: '/ourstory',
            name: 'ourstory',
            component: ourstory
        },
        {
            path: '/joinTeam',
            name: 'joinTeam',
            component: joinTeam,
            meta: {
                title: localStorage.getItem('aspName')
            }
        },
        {
            path: '/tips',
            name: 'tips',
            component: tips,
            meta: {
                title: localStorage.getItem('aspName')
            }
        },
        {
            path: '/tipsDetail/:tipsId/:tipsName',
            name: 'tipsDetail',
            component: tipsDetail
        },
        {
            path: '/inspirationList/:typeId',
            name: 'inspirationList',
            component: inspirationList,
            // meta: {
            //     title: 'inspirationList'
            // }
        },
        {
            path: '/inspiration',
            name: 'inspiration',
            component: inspiration,
            // meta: {
            //     title: 'inspirationList'
            // }
        },
        {
            path: '/rointReward',
            name: 'rointReward',
            component: rointReward,
            // meta: {
            //     title: 'inspirationList'
            // }
        },
        {
            path: '/aftersaleDetails',
            name: 'aftersaleDetails',
            component: aftersaleDetails,
            // meta: {
            //     title: 'inspirationList'
            // }
        },
        {
            path: '/inspirationDetail/:typeId/:id',
            name: 'inspirationDetail',
            component: inspirationDetail
        },
        {
            path: '/showRooms',
            name: 'showRooms',
            component: showRooms,
            meta: {
                title: localStorage.getItem('aspName')
            }
        },
        {
            path: '/showRoomsDetail',
            name: 'showRoomsDetail',
            component: showRoomsDetail
        },
        {
            path: '/registerRetail',
            name: 'registerRetail',
            component: registerRetail,
            meta: {
                title: localStorage.getItem('aspName')
            }
        },
        {
            path: '/registerTrade',
            name: 'registerTrade',
            component: registerTrade,
            meta: {
                title: localStorage.getItem('aspName')
            }
        },
        {
            path: '/goodsList/:goodsTypeId',
            name: 'goodsList',
            component: goodsList,
            meta: {
                keepAlive: true
            }
        },

        {
            path: '/goodsDetail/:goodsId',
            name: 'goodsDetail',
            component: goodsDetail
        },
        {
            path: '/specialOfferList',
            name: 'specialOfferList',
            component: specialOfferList,
            meta: {
                keepAlive: true
            }
        },

        {
            path: '/specialOfferEdit/:productId',
            name: 'specialOfferEdit',
            component: specialOfferEdit
        },
        {
            path: '/bargainPrice',
            name: 'bargainPrice',
            component: () => import('@/pages/goods/bargainPrice')
        },
        {
            path: '/bargainPriceEdit',
            name: 'bargainPriceEdit',
            component: () => import('@/pages/goods/bargainPriceEdit')
        },
        {
            path: '/giftList',
            name: 'giftList',
            component: () => import('@/pages/exchangeMall')
        },
        {
            path: '/giftDetail',
            name: 'giftDetail',
            component: () => import('@/pages/exchangeMall/giftDetail')
        },
        {
            path: '/cart',
            name: 'cart',
            component: cart,
            meta: {
                title: localStorage.getItem('aspName')
            }
        }, {
            path: '/exchangeCart',
            name: 'exchangeCart',
            component: () => import('@/pages/exchangeMall/exchangeCart'),
            meta: {
                title: localStorage.getItem('aspName')
            }
        },
        {
            path: '/exchangeCheckout',
            name: 'exchangeCheckout',
            component: () => import('@/pages/exchangeMall/exchangeCheckout'),
        },
        {
            path: '/exchangeMallmm',
            name: 'exchangeMallmm',
            component: () => import('@/pages/exchangeMall/exchangeMallmm'),
        },
        {
            path: '/viewExchangeMall/:orderId',
            name: 'viewExchangeMall',
            component: () => import('@/pages/exchangeMall/viewExchangeMall'),
        },
        {
            path: '/memberWishlist',
            name: 'wishlist',
            component: wishlist,
            meta: {
                title: localStorage.getItem('aspName')
            }
        },
        {
            path: '/memberOrderList',
            name: 'orderList',
            component: orderList,
            meta: {
                title: localStorage.getItem('aspName')
            }
        },
        {
            path: '/orderChange',
            name: 'orderChange',
            component: () => import('@/pages/member/orderChange')
        },
        {
            path: '/addOrderChange',
            name: 'addOrderChange',
            component: () => import('@/pages/member/addOrderChange')
        },
        {
            path: '/viewOrderChange',
            name: 'viewOrderChange',
            component: () => import('@/pages/member/viewOrderChange')
        },
        {
            path: '/shipInquiry',
            name: 'shipInquiry',
            component: () => import('@/pages/member/shipInquiry')
        },
        {
            path: '/applyReturn/:id',
            name: 'applyReturn',
            component: () => import('@/pages/member/applyReturn')
        },
        {
            path: '/repairList',
            name: 'repairList',
            component: repairList,
            meta: {
                title: localStorage.getItem('aspName')
            }
        },
        {
            path: '/repairAdd',
            name: 'repairAdd',
            component: repairAdd,
            meta: {
                title: localStorage.getItem('aspName')
            }
        },
        {
            path: '/returnGoodList',
            name: 'returnGoodList',
            component: returnGoodList,
            meta: {
                title: localStorage.getItem('aspName')
            }
        },
        {
            path: '/returnGoodDetail',
            name: 'returnGoodDetail',
            component: returnGoodDetail,
            meta: {
                title: localStorage.getItem('aspName')
            }
        },
        {
            path: '/returnDetails/:id',
            name: 'returnDetails',
            component: returnDetails,
            meta: {
                title: localStorage.getItem('aspName')
            }
        },
        {
            path: '/memberOrderDetail/:orderId',
            name: 'orderDetail',
            component: orderDetail
        },
        {
            path: '/memberrepairDetails/:orderId',
            name: 'repairDetails',
            component: repairDetails
        },
        {
            path: '/membershipInquiryDetail/:deliverId',
            name: 'shipInquiryDetail',
            component: () => (import('@/pages/member/shipInquiryDetail'))
        },
        {
            path: '/workOrderList',
            name: 'workOrderList',
            component: workOrderList
        },
        {
            path: '/workOrderEdit/:id',
            name: 'workOrderEdit',
            component: workOrderEdit
        }, {
            path: '/viewWorkOrder/:id',
            name: 'viewWorkOrder',
            component: viewWorkOrder
        },
        {
            path: '/memberAddress',
            name: 'address',
            component: address,
            meta: {
                title: localStorage.getItem('aspName')
            }
        },
        {
            path: '/aftersale',
            name: 'aftersale',
            component: aftersale,
            meta: {
                title: localStorage.getItem('aspName')
            }
        },
        {
            path: '/aftersalesservice',
            name: 'aftersalesservice',
            component: aftersalesservice,
            meta: {
                title: localStorage.getItem('aspName')
            }
        },
        {
            path: '/memberEditAddress/:index',
            name: 'editAddress',
            component: editAddress
        },
        {
            path: '/memberBasicinfo',
            name: 'basicinfo',
            component: basicinfo
        },
        {
            path: '/memberMyaccount',
            name: 'myaccount',
            component: myaccount,
            meta: {
                title: localStorage.getItem('aspName')
            }
        },
        {
            path: '/memberNewlyincreased',
            name: 'newlyincreased',
            component: newlyincreased,
            meta: {
                title: localStorage.getItem('aspName')
            }
        },
        {
            path: '/memberUpdatepassword',
            name: 'updatepassword',
            component: updatepassword,
            meta: {
                title: localStorage.getItem('aspName')
            }
        },
        {
            path: '/memberMyProject',
            name: 'myProject',
            component: myProject,
            meta: {
                title: localStorage.getItem('aspName')
            }
        },
        {
            path: '/projectrecord/:projectId',
            name: 'projectrecord',
            component: Projectrecord,

        },
        {
            path: '/myIntegral',
            name: 'myIntegral',
            component: myIntegral
        },
        {
            path: '/myrecommend',
            name: 'myrecommend',
            component: myrecommend
        },
        {
            path: '/commission',
            name: 'commission',
            component: commission
        },
        {
            path: '/cartCheckout',
            name: 'checkout',
            component: checkout,
            meta: {
                title: localStorage.getItem('aspName')
            }
        },
        {
            path: '/contactUs/:pages',
            name: 'contactUs',
            component: contactUs
        }, {
            path: '/joinOurTeam',
            name: 'joinOurTeam',
            component: joinOurTeam
        },
        {
            path: '/offlinePayment/:id',
            name: 'offlinePayment',
            component: offlinePayment
        },
        {
            path: '/wxPayment/:id',
            name: 'wxPayment',
            component: wxPayment
        },
        {
            path: '/quickOrder',
            name: 'quickOrder',
            component: () => import('@/pages/member/quickOrder')
        },
        {
            path: '/addProject',
            name: 'addProject',
            component: addProject
        },
        {
            path: '/viewProject',
            name: 'viewProject',
            component: viewProject
        },
        {
            path: '/news',
            name: 'news',
            component: () => import('@/pages/wy/news')
        },
        {
            path: '/yzzInspiration',
            name: 'yzzInspiration',
            component: yzzInspiration
        },
        {
            path: '/yzzInspirationDetail',
            name: 'yzzInspirationDetail',
            component: yzzInspirationDetail
        },
        {
            path: '/brand',
            name: 'brand',
            component: () => import('@/pages/brand')
        },
        {
            path: '/homeDesignServices',
            name: 'homeDesignServices',
            component: () => import('@/pages/index/homeDesignServices')
        },
        {
            path: '/homeDesignSeries',
            name: 'homeDesignSeries',
            component: () => import('@/pages/index/homeDesignSeries')
        },
        {
            path: '/cmsBaseWebSimpleColumnContactUs',
            name: 'cmsBaseWebSimpleColumnContactUs',
            component: () => import('@/pages/webBase')
        },
        {
            path: '/distribution',
            name: 'distribution',
            component: () => import('@/pages/webBase/distribution')
        },
        ]
    }
    ]
})


// WEBPACK FOOTER //
// ./src/router/index.js